import styled from 'styled-components';
import { LAYOUT } from '@/constants/styles';
import { StyledFormField } from '@/components/uielements/form-fields/styles';

export const StyledUserInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledEmailVerification = styled.div`
  text-align: center;

  p {
    margin-bottom: ${LAYOUT.GUTTER * 1.5}px;
  }
`;

export const StyledPhoneDisclosure = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #595959;
  margin: 0px 16px 16px 16px;
`;

export const RightAlignedContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TermsText = styled.p`
  margin-top: 1rem;
  text-align: right;
  white-space: nowrap;
  font-size: 14px;
  color: #000000;

  a {
    color: #007bff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledFormFieldColumn = styled(StyledFormField)`
  display: flex;
  flex-direction: column;
`;
